import React, { useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import InventoryDashboard from './components/InventoryDashboard';

// Create a theme with modern purple gradient colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#667eea',
    },
    secondary: {
      main: '#764ba2',
    },
  },
});

// Configure React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data considered fresh for 1 hour (3600000ms)
      staleTime: 3600000,
      // Cache data for 2 hours (7200000ms) - keeps data even after stale
      cacheTime: 7200000,
      // Retry failed requests 1 time
      retry: 1,
      // Don't refetch on window focus in dev (can be enabled in production)
      refetchOnWindowFocus: false,
      // Keep previous data while fetching new data
      keepPreviousData: true,
    },
  },
});

function App() {
  useEffect(() => {
    // Register service worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/service-worker.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      });
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <InventoryDashboard />
      </ThemeProvider>
      {/* React Query Devtools - only visible in development */}
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  );
}

export default App;
